<script setup lang="ts">
import { NewsDetailPage } from '@features/news'
</script>

<template>
  <news-detail-page />
</template>
